<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="frontmatter" id="ser">
<p class="sert"><a class="page" id="pii"></a><img alt="" height="250" src="images/logo-nmhm.jpg" width="192"/></p>
<p class="serah" style="text-align:center; font-style: normal;">ALSO PUBLISHED IN THE SERIES</p>
<p class="seraft" style="text-align:center;"><i>Musical Vitalities: Ventures in a Biotic Aesthetics of Music</i></p>
<p class="serau" style="text-align:center;">Holly Watkins</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-yearsley-0003.vue?32e921a2